import React from 'react';
import './ContactUs.css';
import { useTranslation } from "react-i18next";

function ContactUs() {
    const { t } = useTranslation();
    return (
        <div className="contact-us-page">
            <h1>{t("Contact Details")}</h1>
            <div className="contact-details-container">
                <div>
                    <div className="card">
                        <div className="contact-us-info"><span className="fa location"></span>
                            <div className="card-info">
                                <h4>{t("Our Location:")}</h4>
                                <p>
                                    <a
                                        href="https://www.google.com/maps/search/?api=1&query=Kefallinias+11+Athens,+11361+Greece"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t("Str. 11, Kefallinias, Athens, 11 361, Greece")}
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="contact-us-info"><span className="fa work-hours"></span>
                            <div className="card-info">
                                <h4>{t("Work time:")}</h4>
                                <p>{t("Monday-Friday: 8.00 AM - 6.00 PM")}</p>
                                <p>{t("Weekend: Upon Request")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="card">
                        <div className="contact-us-info"><span className="fa phone-number"></span>
                            <div className="card-info">
                                <h4>{t("Phone number:")}</h4>
                                <p>{t("Mob.")}: +30 694 414 3750</p>
                                <p>{t("Tel.")}: +30 210 8225635</p>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="contact-us-info"><span className="fa email"></span>
                            <div className="card-info">
                                <h4>Email:</h4>
                                <p>abougabal.mm@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
)
    ;
}

export default ContactUs;
